export default "__VITE_ASSET__915760d3__"